//#region src/string/casing.ts
function pascalCase(str) {
	return str.replace(/[-_](.)/g, (_, c) => c.toUpperCase()).replace(/^(.)/, (_, c) => c.toUpperCase());
}
function camelCase(str) {
	return pascalCase(str).replace(/^(.)/, (_, c) => c.toLowerCase());
}
function kebabCase(str) {
	return str.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);
}
function snakeCase(str) {
	return str.replace(/[A-Z]/g, (m) => `_${m.toLowerCase()}`);
}
//#endregion
export { camelCase, kebabCase, pascalCase, snakeCase };

//# sourceMappingURL=casing.js.map